import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { CustomerVehiclesState } from '../../types';

export const initialState: CustomerVehiclesState = {
    deals: [],
    selectedVehicle: null,
    requestStatus: ApiRequestStatus.Idle,
    error: null,
    isOpen: false,
    isActive: false,
    isDealListCompareEnabled: false,
    isTradeInModalVisible: false,
    customerFirstName: undefined,
    dealsCount: 0,
    updateTradeInsStatus: ApiRequestStatus.Idle
};
